import { useNavigate } from 'react-router-dom';

import { paths } from '@/app/router/paths';
import { AcceptPartnerInvitationOverviewForm } from '@/features/partners/components/pages/accept-partner-invitation-overview-form';
import { useAcceptSubprojectInvitationMutation } from '@/features/partners/hooks/use-subproject-invitation-mutation';
import { useAcceptSubprojectInvitationStore } from '@/features/partners/store/use-accept-subproject-invitation-store';

interface AcceptInvitationInviteMembersOverviewPageProps {
  invitationToken: string;
}

export const AcceptInvitationInviteMembersOverviewPage = ({
  invitationToken,
}: AcceptInvitationInviteMembersOverviewPageProps) => {
  const { data, setData } = useAcceptSubprojectInvitationStore();
  const navigate = useNavigate();
  const { mutate: acceptInvitation } = useAcceptSubprojectInvitationMutation({
    onSuccess: (data) => {
      if (!data) {
        navigate(paths.home.getHref());
        return;
      }

      navigate(paths.projects.details.base.getHref(data.toString()));
    },
  });

  const handleAddMore = () => {
    setData({ step: 'inviteMembersInput' });
  };

  const handleBack = () => {
    if (Object.keys(data.kpiBudgets || {}).length > 0) {
      setData({ step: 'budgets' });
    } else {
      setData({ step: 'subcategory' });
    }
  };

  const handleSubmitAll = () => {
    return acceptInvitation({
      orgId: data.orgId!,
      subprojectName: data.subprojectName!,
      subprojectDescription: data.subprojectDescription,
      contactPerson: data.contactPerson!,
      selectedCategory: data.selectedCategory,
      selectedSubcategory: data.selectedSubcategory,
      kpiBudgets: data.kpiBudgets,
      invitedMembers: data.invitedMembers,
      invitationToken,
    });
  };

  const handleRemove = (userId: string) => {
    setData({
      invitedMembers: data.invitedMembers?.filter((m) => m.user_id !== userId),
    });
  };

  return (
    <AcceptPartnerInvitationOverviewForm
      invitations={data.invitedMembers || []}
      onAddMore={handleAddMore}
      onBack={handleBack}
      onSubmitAll={handleSubmitAll}
      handleRemove={handleRemove}
    />
  );
};
